var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJobId = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,.875A6.125,6.125,0,1,1,.875,7,6.132,6.132,0,0,1,7,.875M7,0a7,7,0,1,0,7,7A7,7,0,0,0,7,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.507,5.6H6.6v5.388H5.507Z",
    transform: "translate(-1.224 -1.245)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.987,5.6h2.1a2.456,2.456,0,0,1,2.366,2.75,2.7,2.7,0,0,1-.859,2.118,2.4,2.4,0,0,1-1.6.52H7.987ZM9.924,10.05c1.024,0,1.424-.626,1.424-1.7s-.467-1.816-1.395-1.816H9.08V10.05Z",
    transform: "translate(-1.775 -1.245)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJobId);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/job-id.672b40a01a1d72a29dfbdf94f2246edb.svg";